import script from "./ExportConfigsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ExportConfigsTab.vue?vue&type=script&setup=true&lang=js"

import "./ExportConfigsTab.vue?vue&type=style&index=0&id=a29ad11a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a29ad11a"]])

export default __exports__